var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1411 6.84532C11.6095 6.57072 12.1898 6.57072 12.6582 6.84532L21.2917 11.9064C22.2803 12.4859 22.2803 13.9149 21.2918 14.4944L12.6582 19.5555C12.1898 19.8301 11.6095 19.8301 11.1411 19.5555L2.50754 14.4944C1.51898 13.9149 1.51898 12.4859 2.50754 11.9064L11.1411 6.84532Z",
    fill: "#CFEFB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1411 3.64317C11.6095 3.36857 12.1898 3.36857 12.6582 3.64317L21.2917 8.7042C22.2803 9.2837 22.2803 10.7128 21.2918 11.2923L12.6582 16.3533C12.1898 16.6279 11.6095 16.6279 11.1411 16.3533L2.50754 11.2923C1.51898 10.7128 1.51898 9.2837 2.50754 8.7042L11.1411 3.64317Z",
    fill: "#B6D79A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1411 0.444685C11.6095 0.170081 12.1898 0.17008 12.6582 0.444684L21.2917 5.50572C22.2803 6.08522 22.2803 7.51431 21.2918 8.09381L12.6582 13.1548C12.1898 13.4294 11.6095 13.4294 11.1411 13.1548L2.50754 8.09381C1.51898 7.51431 1.51898 6.08522 2.50754 5.50572L11.1411 0.444685Z",
    fill: "#95B47C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOb);
export default __webpack_public_path__ + "static/media/ob.d9ac50d2d91ede1a85929beaeedc5702.svg";
export { ForwardRef as ReactComponent };